// ============================================================================
// CONTENT MANAGER REPOSITORY
// ARQUIVO: src/features/academy/admin/ContentManagerRepository.js
// RESPONSABILIDADE: Isolar todas as chamadas Firestore do ContentManager.
// ============================================================================

import {
  collection, addDoc, updateDoc, deleteDoc, doc,
  query, orderBy, getDocs, serverTimestamp, writeBatch
} from 'firebase/firestore';
import { db } from '../../../shared/api/firebase/config';

const COLLECTION_NAME = 'academy_classes';

export const fetchAcademyClasses = async () => {
  const q = query(collection(db, COLLECTION_NAME), orderBy('orderIndex', 'asc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const createAcademyClass = async (payload) => {
  const enriched = { ...payload, createdAt: serverTimestamp(), orderIndex: payload.orderIndex ?? 0 };
  const ref = await addDoc(collection(db, COLLECTION_NAME), enriched);
  return ref.id;
};

export const updateAcademyClass = async (id, payload) => {
  await updateDoc(doc(db, COLLECTION_NAME, id), { ...payload, updatedAt: serverTimestamp() });
};

export const deleteAcademyClass = async (id) => {
  await deleteDoc(doc(db, COLLECTION_NAME, id));
};

export const reorderAcademyClasses = async (newOrder) => {
  const batch = writeBatch(db);
  newOrder.forEach((item, idx) => {
    batch.update(doc(db, COLLECTION_NAME, item.id), { orderIndex: idx });
  });
  await batch.commit();
};
